<script setup lang="ts">
import { useNetwork } from '@vueuse/core';
import DialogResponse from './Dialog/Response.vue';

const { isOnline } = useNetwork();
</script>

<template>
	<DialogResponse
		title="You're offline"
		:has-close="false"
		:visible="!isOnline"
	>
		<div class="d:flex flex:col gap:16">
			<p>
				It looks like you've lost your internet connection.
			</p>
			<p>
				Changes you make now may not be saved. This message will close automatically once you're back online.
			</p>
		</div>
	</DialogResponse>
</template>
